var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"erji-title"},[_c('h1',{staticClass:"fl"},[_vm._v(_vm._s(_vm.titleName))]),_c('div',{staticClass:"mianbaoxie fr visible-lg-block"},[_c('i',[_vm._v("首页")]),_vm._v(" > "),_c('i',[_vm._v(_vm._s(_vm.fatherName))]),_vm._v(" > "),_c('span',[_vm._v(_vm._s(_vm.titleName))])]),_c('div',{staticClass:"clear"})])
}
var staticRenderFns = []

export { render, staticRenderFns }